<template>
  <div class="point-course">
    <ShadowBox
      class="shadow-box"
      opacity="_60"
    >
      <div class="point-area">
        <span class="point">{{ point | comma }}</span>
      </div>
      <span class="value">
        <span v-if="i18n_mode == 'jp'">¥</span>{{price | comma}}
        <span v-if="i18n_mode != 'jp'">yen</span>
      </span>
      <BlackGradationButton
        :text="t('購入')"
        class="square-button"
        @handleSquareBtnClick="handleBuyBtnClick"
      />
      <div class="memo">{{memo}}</div>
    </ShadowBox>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';

import ShadowBox from '@/components/atoms/ShadowBox.vue';
// import SquareButton from '@/components/atoms/SquareButton.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'PointCourse',
  mixins: [t],

  components: {
    ShadowBox,
    // SquareButton,
    BlackGradationButton,
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(parseInt(value, 10));
    },
  },

  props: {
    point: {
      type: String,
    },
    price: {
      type: String,
    },
    memo: {
      type: String,
    },
  },

  computed: {
    bonusPoint() {
      const bonusPoint = parseInt(this.point, 10) - parseInt(this.price, 10);
      return separateCharacterNumber(bonusPoint);
    },
  },

  methods: {
    handleBuyBtnClick() {
      this.$emit('handleBuyBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.point-course{
  text-align: left;
  width: 100%;
  .shadow-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding: 10px;
    font-family: $notoSans;
    font-size: 20px;
    flex-wrap: wrap;
    .point-area{
      display: flex;
      flex-wrap: wrap;
      .point{
        font-weight: 700;
        line-height: 29px;
        color: $black;
        &:before {
          content: "P";
          width: 30px;
          height: 30px;
          border-radius: 100px;
          background-color: $mainColor;
          margin-right: 10px;
          color: $white;
          display: inline-flex;
          justify-content: center;
          align-items: center;
        }
      }
      .point-service{
        font-size: 12px;
      }
    }
    .value{
      margin-left: auto;
      color: $black;
      margin-right: 20px;
    }
    .square-button{
      width: 100px;
      height: 36px;
    }
  }
}
.memo {
  width: 100%;
  margin-left: 40px;
  font-size: 12px;
  color: $red;
}
@media screen and  (max-width: $tabletWidth) {
  .point-course{
    width: 100%;
    .shadow-box {
      font-size: 16px;
      padding: 10px 0;
    }
  }
}
</style>
